import styled from 'styled-components';

export const HeaderName = styled.h1`
  font-size: 21px;
  font-family: Blinker, sans-serif;
  //margin-bottom: 32px;
  font-weight: 700;
`;
